import React from 'react';

const ErrorPreviewModal = ({ show, onClose, errorData }) => {
  if (!show || !errorData) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) => {
    if (!value) return 'N/A';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(value));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-red-600">Advertisement Preview</h2>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <span className="text-2xl">&times;</span>
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="bg-gray-50 p-4 rounded">
              <h3 className="font-medium text-gray-700 mb-2">Basic Information</h3>
              <div className="space-y-1 text-sm">
                <p><span className="font-medium">ID:</span> {errorData.id || 'N/A'}</p>
                <p><span className="font-medium">Campaign:</span> {errorData.campaign_name || 'N/A'}</p>
                <p><span className="font-medium">Newspaper:</span> {errorData.newspaper_name || 'N/A'}</p>
                <p><span className="font-medium">Edition:</span> {errorData.edition || 'N/A'}</p>
                <p><span className="font-medium">Page:</span> {errorData.page_name || 'N/A'}</p>
                <p><span className="font-medium">Date:</span> {formatDate(errorData.date)}</p>
              </div>
            </div>

            <div className="bg-gray-50 p-4 rounded">
              <h3 className="font-medium text-gray-700 mb-2">Advertisement Details</h3>
              <div className="space-y-1 text-sm">
                <p><span className="font-medium">Format:</span> {errorData.ad_format || 'N/A'}</p>
                <p><span className="font-medium">Type:</span> {errorData.ad_type || 'N/A'}</p>
                <p><span className="font-medium">Estimated Value:</span> {formatCurrency(errorData.estimated_value)}</p>
              </div>
            </div>
          </div>

          {errorData.dimensions && (
            <div className="bg-gray-50 p-4 rounded mb-4">
              <h3 className="font-medium text-gray-700 mb-2">Dimensions & Position</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <p className="font-medium">Position</p>
                  <p>X: {errorData.dimensions.x || 'N/A'}</p>
                  <p>Y: {errorData.dimensions.y || 'N/A'}</p>
                </div>
                <div>
                  <p className="font-medium">Size (px)</p>
                  <p>Width: {errorData.dimensions.px || 'N/A'}</p>
                  <p>Height: {errorData.dimensions.py || 'N/A'}</p>
                </div>
                <div>
                  <p className="font-medium">Size (cm)</p>
                  <p>Width: {errorData.dimensions.w || 'N/A'}</p>
                  <p>Height: {errorData.dimensions.h || 'N/A'}</p>
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
              Close
            </button>
            <a
              href={errorData.image_url}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              View Full Image
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPreviewModal;
